export default "__VITE_ASSET__D1xed8Mk__"